const VERSION = "5.2.1";
export {
  VERSION
};
